import React from 'react';

import TasksPage from './tasks-page';

interface Props {
  className?: string;
}

const Tasks: React.FC<Props> = ({ className }) => {
  return <TasksPage className={className} />;
};

export default Tasks;
